export default __webpack_public_path__ + "static/media/post-tile.png.webp";